import React, {
  Suspense,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import axios from "../../api/axios";
import FetchContent from "../dynamic/fetchContent";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import FetchImage from "../dynamic/fetchImage";
import ImageContent from "../dynamic/ImageContent";
import Content from "../dynamic/Content";
import { EditButtonLarge, SaveButton, CancelButton } from "../buttons/Buttons";

const WEBSITE_URL = "/websitejson";
const JSON_KEY = "special-offers-links";
const ART = "en"; // or use `defaultLanguage` if multilingual

export const SpecialOffers = () => {
  const { username, auth } = useAuth();
  const { t } = useTranslation();

  const [editingId, setEditingId] = useState(0);
  const [tempLink, setTempLink] = useState("");

  const [links, setLinks] = useState([
    { id: 1, title: "Card 1", link: "" },
    { id: 2, title: "Card 2", link: "" },
    { id: 3, title: "Card 3", link: "" },
  ]);

  const linksRef = useRef(links);
  useEffect(() => {
    linksRef.current = links;
  }, [links]);

  const normalizeUrl = (url) => {
    if (!url) return "#";
    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };

  const fetchLinks = useCallback(async () => {
    try {
      const response = await axios.get(WEBSITE_URL, {
        params: { username, art: ART, title: JSON_KEY },
      });
      if (response.data.entry) {
        const jsonData = JSON.parse(response.data.entry.content);
        if (jsonData !== "default text") {
          setLinks(jsonData);
        }
      }
    } catch (err) {
      console.error("Error fetching links:", err);
    }
  }, [username]);

  useEffect(() => {
    fetchLinks();
  }, [fetchLinks]);

  const handleEditClick = (item) => {
    setEditingId(item.id);
    setTempLink(item.link);
  };

  const handleCancelClick = () => {
    setEditingId(0);
    setTempLink("");
  };

  const handleSaveClick = async (e) => {
    e.preventDefault();
    const updated = [...links];
    const index = updated.findIndex((r) => r.id === editingId);
    if (index !== -1) {
      updated[index].link = tempLink;
    }

    setLinks(updated);
    setEditingId(0);
    setTempLink("");

    try {
      await axios.put(WEBSITE_URL, {
        username,
        art: ART,
        title: JSON_KEY,
        content: updated,
      });
    } catch (err) {
      console.error("Error saving links:", err);
    }

    fetchLinks();
  };

 const renderClaimSection = (item) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      {editingId === item.id && auth?.role ? (
        <>
          <input
            type="text"
            value={tempLink}
            onChange={(e) => setTempLink(e.target.value)}
            style={{
              width: "90%",
              padding: "6px",
              marginBottom: "10px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
          <div>
            <SaveButton buttonText="Save" onClick={handleSaveClick} />
            <CancelButton buttonText="Cancel" onClick={handleCancelClick} />
          </div>
        </>
      ) : (
        <>
          <a
            href={normalizeUrl(item.link)}
            className="other-services-span"
            target="_blank"
            rel="noopener noreferrer"
          >
          Claim Now
          </a>
          {auth?.role && (
            <div style={{ marginTop: "8px" }}>
              <EditButtonLarge
                buttonText={t("button.edit") || "Edit"}
                onClick={() => handleEditClick(item)}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

  return (
    <div className="default">
      <div>
        <Suspense fallback={<h1>Still Loading…</h1>}>
          {!auth?.role ? (
            <FetchImage title="special-offers-main" type="image-about" />
          ) : (
            <ImageContent
              title="special-offers-main"
              username={username}
              type="image-about"
            />
          )}
        </Suspense>
      </div>
      <div className="contact-title">
        {" "}
        <h1>{t("special_offers_page.special-offers")}</h1>{" "}
      </div>
      <div className="stripe container about-us-main">
        <div className="about-us-main-img">
          {!auth?.role ? (
            <FetchImage
              title="special-offers-image1"
              type="about-us-main-img-container"
            />
          ) : (
            <ImageContent
              title="special-offers-image1"
              username={username}
              type="image-about"
            />
          )}
        </div>

        <div className="about-us-main-content">
          {!auth?.role ? (
            <h2>
              <FetchContent title="special-offers-h1" />
            </h2>
          ) : (
            <h2>
              <Content title={"special-offers-h1"} styling="p" />
            </h2>
          )}
          {!auth?.role ? (
            <div className="p-brandnew">
              <FetchContent title="special-offers-p1" />
            </div>
          ) : (
            <div className="p-brandnew">
              <Content title={"special-offers-p1"} styling="p" />
            </div>
          )}
        </div>
      </div>
      <div className="stripe container about-us-main">
        <div className="about-us-main-content">
          {!auth?.role ? (
            <h2>
              <FetchContent title="special-offers-h2" />
            </h2>
          ) : (
            <h2>
              <Content title={"special-offers-h2"} styling="p" />
            </h2>
          )}
          {!auth?.role ? (
            <div className="p-brandnew">
              <FetchContent title="special-offers-p2" />
            </div>
          ) : (
            <div className="p-brandnew">
              <Content title={"special-offers-p2"} styling="p" />
            </div>
          )}
        </div>

        <div className="about-us-main-img">
          {!auth?.role ? (
            <FetchImage
              title="special-offers-image2"
              type="about-us-main-img-container"
            />
          ) : (
            <ImageContent
              title="special-offers-image2"
              username={username}
              type="image-about"
            />
          )}
        </div>
      </div>

      <div className="contact-title">
        <h1>{t("special_offers_page.special-offers")}</h1>
      </div>

      <div className="container other-services-container">
        {links.map((item) => (
          <div className="other-services-item" key={item.id}>
            <div className="other-services-image">
              {!auth?.role ? (
                <FetchImage
                  title={`special-offers-card${item.id}`}
                  type="other-services-image"
                />
              ) : (
                <ImageContent
                  title={`special-offers-card${item.id}`}
                  username={username}
                  type="image-about"
                />
              )}
              {!auth?.role ? (
                <span>
                  <FetchContent title={`special-offers-card${item.id}`} />
                </span>
              ) : (
                <span>
                  <Content
                    title={`special-offers-card${item.id}`}
                    styling="p"
                  />
                </span>
              )}
            </div>
            {renderClaimSection(item)}
          </div>
        ))}
      </div>
    </div>
  );
};
